export const ROW_PER_PAGE_OPTIONS = [10, 20, 30, 40, 50];
